var _path, _circle, _circle2, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourceToPay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-source-to-pay"
  }, "Source-to-Pay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-source-to-pay"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4h2l1.6 8.2a1.6 1.6 0 0 0 1.57 1.3H12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 18,
    r: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 18,
    r: 1.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 8,
    height: 12,
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5c0-0.8 0.7-1.3 1.5-1.3 0.8 0 1.5 0.6 1.5 1.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5V13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11h3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceToPay);
export default __webpack_public_path__ + "static/media/source-to-pay.15a04969a0f7d4ac74a41462e97c49e9.svg";
export { ForwardRef as ReactComponent };